<template>
  <div>
    <custom-callout
      has-border
      :has-toggle="false"
      :border-color="getStatusStyle(item.status?.id)"
      :opened="item.isOpen"
    >
      <div class="row align-items-center p-3">
        <span>
          <CheckBox
            v-if="
              needsCompServices &&
                isServiceSubmitted &&
                !peiFirmedAndServiceFromCurrentPei
            "
            v-model="item.selectedToCompensate"
            class="font-weight-light text-md-nowrap"
            :disabled="isDisabled"
          />
        </span>
        <div
          v-if="isServiceSubmitted"
          class="col-12 col-lg-2 border-right d-flex flex-column align-items-center justify-content-center"
        >
          <span
            class="p-3 badge badge-pill font-weight-bold"
            :style="{ backgroundColor: getStatusStyle(item.status?.id) }"
          >
            {{ item.status?.name | empty }}
          </span>
          <small class="text-dark mt-1 font-weight-bold">
            {{ item.requestNumber }}
          </small>
        </div>

        <div class="col-12 col-lg-1 text-center">
          <div class="text-muted font-weight-light small">Año Académico</div>
          <div class="font-weight-bold">
            {{ item?.academicYear?.description | empty }}
          </div>
        </div>

        <div class="col-12 col-lg-2 text-center">
          <div class="text-muted font-weight-light small">Servicio</div>
          <div class="font-weight-bold">
            {{ item?.disciplineType.name | empty }}
          </div>
        </div>

        <div class="col-12 col-lg-1 text-center">
          <div class="text-muted font-weight-light small">
            Horas Adeudadas
          </div>
          <div class="font-weight-bold">
            {{ item.interventionHour | empty }}
          </div>
        </div>
        <div class="col-12 col-lg-2 text-center">
          <div class="text-muted font-weight-light small">Horas Ofrecidas</div>
          <div class="font-weight-bold">
            {{ item.offeredHours.toFixed(2) | empty }}
          </div>
        </div>

        <div :class="['col-12', isServiceSubmitted ? 'col-lg-2' : 'col-lg-2']">
          <div class="text-center">
            <div class="text-muted font-weight-light small">Balance</div>
            <div class="font-weight-bold mb-0">{{ balance }}</div>
          </div>
        </div>

        <!-- Dropdown de acciones -->
        <div
          v-if="!isDisabled"
          :class="[
            'col-12',
            !isDisabled
              ? 'd-flex justify-content-center justify-content-lg-end col-lg-1'
              : 'd-flex justify-content-center justify-content-lg-end col-lg-2',
          ]"
        >
          <drop-down
            v-if="needsCompServices || needsCompServices == null"
            always-show-dropdown
            :items="actionItems"
          />
          <action-button
            v-else
            :disabled="isDisabled"
            i="fas fa-times-circle"
            variant="outline-danger"
            @click="openReject(item)"
          >
            Rechazar
          </action-button>
        </div>
      </div>
      <Error
        v-if="
          Boolean(item.rejectionDocumentAttachmentId) &&
            isRequestRejected &&
            item.peiId == pei
        "
        class="mt-3 pl-3"
        is-alert-mode
        message="Al firmar el PEI, la planilla será cambiada al estatus: Rechazada. Favor oprimir Acciones y Rechazar, para ver o actualizar la información ingresada."
      />
      <RejectCompensatoryService
        :key="item.requestNumber"
        v-if="isRejectionFormVisible"
        :compensatoryRequestNumber="item"
        :fileName="item.fileName"
        :documentAttachmentId="item.rejectionDocumentAttachmentId"
        :isReadOnly="isDisabled"
        @document="getDocument"
        @save-doc="saveDocument()"
        @cancel-section="isRejectionFormVisible = false"
      />
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import DropDown from 'dropdown';
import mixAlert from '@/mixin/alert.mixin';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus.js';
import store from '@/store/index';
import peiStatusEnum from '@/utils/constants/pei/peiStatus.js';
import CheckBox from 'CheckBox';
import RejectCompensatoryService from '@/components/pei/programservice/tabs/components/RejectCompensatoryService.vue';
import generalService from '@/services/pei/general';
import objectToFormData from 'object-to-formdata';
import Error from '@/components/common/Error';

export default {
  name: 'EducationalServicesRow',
  components: {
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    CustomBalloon,
    DropDown,
    CheckBox,
    RejectCompensatoryService,
    Error,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
    needsCompServices: {
      type: Boolean,
      default: () => true,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    isFromCurrentPei: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      action: null,
      isRejectionFormVisible: false,
      document: null,
      pei: store.getters.SelectedPei,
    };
  },
  computed: {
    isServiceSubmitted() {
      return Boolean(this.item?.isSubmitted);
    },
    isRequestRejected() {
      return this.item.status?.id == compensatoryRequestStatus.RequestRejected;
    },
    peiFirmedAndServiceFromCurrentPei() {
      return (
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Firmado) &&
        this.isFromCurrentPei
      );
    },
    isPeiDraft() {
      return store.getters.SelectedPeiStatus == Number(peiStatusEnum.Borrador);
    },
    isPeiCompleted() {
      return (
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Completado)
      );
    },
    actionItems() {
      return [
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          visible: !this.isServiceSubmitted,
          click: () => this.$emit('remove', this.index, this.item),
        },
        {
          name: 'Modificar',
          icon: 'fas fa-pencil text-green text-green',
          visible: this.canModifyService,
          click: () => this.$emit('edit', this.item),
        },
        {
          name: 'Rechazar',
          icon: 'fas fa-times-circle text-danger',
          visible: this.canRejectService,
          click: () => this.openReject(),
        },
      ];
    },
    balance() {
      return (
        (this.item.interventionHour ?? 0) - (this.item.offeredHours ?? 0)
      ).toFixed(2);
    },
    canModifyService() {
      return (
        this.userHasPermissions(
          'academic.pei.compensatoryservices.educational.edit'
        ) &&
        (this.isServiceSubmitted || Boolean(this.item.requestNumber)) &&
        this.isPeiDraft
      );
    },
    canRejectService() {
      return this.isServiceSubmitted && this.isPeiDraft;
    },
  },
  methods: {
    openReject() {
      this.isRejectionFormVisible = true;
    },
    async saveDocument() {
      const formData = objectToFormData(this.document, { indices: true });
      formData.append(`document`, this.document.file);
      formData.append(`requestId`, this.item.id);
      await generalService.rejectEducationalService(formData);
      this.$emit('refresh');
      this.isRejectionFormVisible = false;
    },
    getDocument(doc) {
      this.document = doc;
    },
    getStatusStyle(status) {
      switch (status) {
        case compensatoryRequestStatus.ProcessCompleted:
        case compensatoryRequestStatus.Approved:
        case compensatoryRequestStatus.ApprovedModified:
          return '#a3e5b3';
        case compensatoryRequestStatus.CompletedPendingApproval:
        case compensatoryRequestStatus.Submitted:
          return '#fff3cd';
        case compensatoryRequestStatus.New:
          return '#e2e3e5';
        case compensatoryRequestStatus.Denied:
        case compensatoryRequestStatus.RequestRejected:
        case compensatoryRequestStatus.ExcludedByStrategy:
        case compensatoryRequestStatus.ExcludedGraduated:
        case compensatoryRequestStatus.ExcludedServiceHigh:
          return '#f8d7da';
        case compensatoryRequestStatus.ProcessDiscussion:
          return '#e2d6f3';
        default:
          return '#b5c3bc';
      }
    },
  },
};
</script>

<style scoped>
::v-deep(.position-relative > label) {
  font-weight: 700 !important;
}
</style>
